import { epi, meta, sectionHeading } from '@mage-ui/styled-system/recipes';

export const SectionHeadingTop = ({ data, ...props }) => {
  const classes = sectionHeading();
  return (
    (data?.epi || data?.meta) && (
      <div className={classes.top} {...props}>
        {data?.epi && <span className={epi()}>{data?.epi}</span>}
        {data?.meta && (
          <span
            className={meta()}
            dangerouslySetInnerHTML={{ __html: data?.meta }}
          />
        )}
      </div>
    )
  );
};
